import {
  KnownAction,
  RECEIVE_AUTHORIZATIONS,
  REQUEST_AUTHORIZATIONS,
} from "./AuthorizationAction";
import { createStore, Store } from "redux";
import { Authorization } from "./Interfaces";

export interface State {
  authorizations: Authorization;
  isLoading: boolean;
  isError: boolean;
  startDateIndex?: string;
}

export const initialState: State = {
  authorizations: {
    internalrole: "",
    adminrole: false,
    adminuserrole: false,
    ctsuserrole: false,
    cssuserrole: false,
    cwpretailrole: false,
  },
  isLoading: false,
  isError: false,
};

export const reducer = (state = initialState, action: KnownAction): State => {
  switch (action.type) {
    case REQUEST_AUTHORIZATIONS:
      return {
        authorizations: state.authorizations,
        isError: state.isError,
        isLoading: true,
      };

    case RECEIVE_AUTHORIZATIONS: {
      const newcoll = state.authorizations;
      // {
      //   internalrole: string;
      //   adminrole: boolean;
      //   adminuserrole: boolean;
      //   ctsuserrole: boolean;
      //   cssuserrole: boolean;
      //   cwpretailrole: boolean;
      // }
      newcoll.adminrole = (action.payload.authorizations.adminrole)?action.payload.authorizations.adminrole:state.authorizations.adminrole;
      newcoll.internalrole = (action.payload.authorizations.internalrole)?action.payload.authorizations.internalrole:state.authorizations.internalrole;
      newcoll.adminuserrole = (action.payload.authorizations.adminuserrole)?action.payload.authorizations.adminuserrole:state.authorizations.adminuserrole;
      newcoll.ctsuserrole = (action.payload.authorizations.ctsuserrole)?action.payload.authorizations.ctsuserrole:state.authorizations.ctsuserrole;
      newcoll.cssuserrole = (action.payload.authorizations.cssuserrole)?action.payload.authorizations.cssuserrole:state.authorizations.cssuserrole;
      newcoll.cwpretailrole = (action.payload.authorizations.cwpretailrole)?action.payload.authorizations.cwpretailrole:state.authorizations.cwpretailrole;

      return {
        authorizations: newcoll,
        isLoading: false,
        isError: action.isError,
      };
    }

    default:
      return state;
  }
};

const store: Store<State, KnownAction> = createStore(reducer);

export { store };
